import React from "react";
import CustomInput from "../CustomInput";
import CustomHourPiker from "./CustomHourPiker";
import { IHourTiming } from "../../types/school.interface";

type Props = {
  defaultValue: {
    hour?: string | number;
    minute?: string | number;
  };
  inputName?: string;
  onChange: (time: IHourTiming) => void;
  isNotPiker?: boolean;
};

const TimePicker = (props: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <section>
      <CustomInput
        onClick={() => setIsOpen(!isOpen)}
        value={
          props.defaultValue?.hour || props.defaultValue?.minute
            ? `${props.defaultValue?.minute ? props.defaultValue?.minute : "00"} : ${props.defaultValue?.hour ? props.defaultValue?.hour : "00"}`
            : props.inputName
        }
      />
      <CustomHourPiker
        time={props.defaultValue}
        isOpen={!props.isNotPiker && isOpen}
        onChangeTime={(time: any) => props.onChange(time)}
        setIsOpen={setIsOpen}
      />
    </section>
  );
};

export default TimePicker;
